export type HlsController = {
  detach(): void;
};

export async function attachHls(video: HTMLVideoElement, src: string): Promise<HlsController | null> {
  const mod = await import('hls.js').catch(() => null as any);
  if (!mod) return null;
  const Hls = mod.default || mod;
  if (!Hls || !Hls.isSupported || !Hls.isSupported()) return null;
  
  const hlsConfig = {
    // Mobile-specific optimizations
    startLevel: -1, // Auto-select initial quality
    capLevelToPlayerSize: true, // Don't load higher res than needed
    maxBufferLength: 30, // Reduce buffer for mobile
    maxMaxBufferLength: 60, // Maximum buffer length
    // Better error recovery
    fragLoadingTimeOut: 20000,
    manifestLoadingTimeOut: 10000,
    levelLoadingTimeOut: 10000,
  };
  
  const hls = new Hls(hlsConfig);
  
  // Add error handling for mobile-specific issues
  hls.on(Hls.Events.ERROR, (event: any, data: any) => {
    if (data.fatal) {
      switch (data.type) {
        case Hls.ErrorTypes.NETWORK_ERROR:
          // eslint-disable-next-line no-console
          console.warn('HLS network error, attempting recovery');
          hls.startLoad();
          break;
        case Hls.ErrorTypes.MEDIA_ERROR:
          // eslint-disable-next-line no-console
          console.warn('HLS media error, attempting recovery');
          hls.recoverMediaError();
          break;
        default:
          // eslint-disable-next-line no-console
          console.warn('HLS fatal error:', data);
          hls.destroy();
          break;
      }
    }
  });
  
  hls.loadSource(src);
  hls.attachMedia(video);
  
  return {
    detach() {
      try {
        hls.stopLoad?.();
        hls.detachMedia?.();
        hls.destroy?.();
      } catch {}
    },
  };
}

